import { useState, useEffect } from 'react';
import { getUserSettings, updateUserSettings as apiUpdateUserSettings } from '../services/api';

export const useUserSettings = (setMessage) => {
    const [userSettings, setUserSettings] = useState(null);

    const loadUserSettings = async () => {
        try {
            // Assuming userId 1 for now
            const settings = await getUserSettings(1);
            setUserSettings(settings);
        } catch (err) {
            console.error("Error loading user settings:", err);
        }
    };

    const updateUserSettings = async (settings) => {
        try {
            await apiUpdateUserSettings(1, settings);
            setUserSettings(settings);
            setMessage({ text: 'Settings saved successfully!', type: 'success', open: true });
            return true;
        } catch (err) {
            console.error("Error updating settings:", err);
            setMessage({ text: 'Failed to save settings', type: 'error', open: true });
            return false;
        }
    };

    return {
        userSettings,
        setUserSettings,
        loadUserSettings,
        updateUserSettings
    };
};
